<button (click)="openFileDialog()" mat-button color="primary">
  {{ 'csvUpload.uploadFileButtonText' | translate }}
</button>
